import { render } from "./TheFooter.vue?vue&type=template&id=a36b5ed2"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=a36b5ed2&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "C:\\Users\\GuoRita\\OneDrive - MSFT\\git\\song-yo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__